<template>
  <div>
    <h1 class="header-tus text-center text-3xl font-bold py-5">Specialni siri</h1>
    <p class="text-center py-5">Prosimo vas, da si vzamete minuto vašega časa in odgovorite na nekaj vprašanj.
      Hvala.</p>
    <SurveyQuestion title="Kako ste zadovoljni s ponudbo sirov v naši poslovalnici?"
              question-more="Nam prosim zaupate razlog za vašo oceno?"
              question-more-answer-placeholder="Napišite kaj ste pogrešali, kaj bi lahko bilo boljše..."
              legend-min="Slabo"
              legend-max="Zelo"
              @change="questionChanged" question-id="bn2ab09a7ab511ec90d60242ac120003" v-model="q1" :initial-value="initialAnswer"></SurveyQuestion>
    <EmptySpace></EmptySpace>
    <SurveyQuestion title="Kateri sir bi si želeli v naši ponudbi?"
              :show-score="false"
              :question-more="null"
              question-more-answer-placeholder="Vpišite vaš željeni sir." @change="questionChanged"
              question-id="bna5e0147ab611ec90d60242ac120003" v-model="q2"></SurveyQuestion>
    <EmptySpace></EmptySpace>
    <SurveyQuestion title="Katere izdelke kupite zraven ob nakupu posebne, specialne vrste sira?"
              :show-score="false"
              :question-more="null"
              question-more-answer-placeholder="Vpišite izdelke." @change="questionChanged"
              question-id="bng5e0147ab611ec90d60242ac120003" v-model="q3"></SurveyQuestion>
  </div>
</template>

<script>
import EmptySpace from '@/components/EmptySpace'
import SurveyQuestion from '@/components/SurveyQuestion'
import NPSService from '@/services/nps'

export default {
  name: 'StepQuestionsSiri',
  components: { SurveyQuestion, EmptySpace },
  props: {
    flowId: {}
  },
  data () {
    return {
      npsId: '85bcc16a7ab411ec90d60242ac120003',
      q1: null,
      q2: null,
      q3: null,
    }
  },
  computed: {
    initialAnswer () {
      let parts = window.location.search.split('=')
      if (parts[0] == '?q') {
        return parseInt(parts[1])
      }
      return null
    }
  },
  methods: {
    questionChanged (qId) {
      if (qId.questionId) {
        const npss = new NPSService()
        npss.store(this.npsId, this.flowId, qId.questionId, qId.score, qId.more)
      }
      this.$emit('update:finished', true)
    }
  }
}
</script>

<style scoped>

</style>
